import * as React from "react";
import { Eye, Pencil } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "./Tabs";
import { Textarea } from "./Textarea";
import { ChangelogMarkdown } from "../ChangelogMarkdown";
import { cn } from "../../lib/cn";

export interface MarkdownEditorProps {
  value: string;
  onChange: (value: string) => void;
  rows?: number;
  className?: string;
  placeholder?: string;
}

export const MarkdownEditor: React.FC<MarkdownEditorProps> = ({
  value,
  onChange,
  rows = 18,
  className,
  placeholder = "Conteúdo do changelog em Markdown",
}) => {
  return (
    <Tabs defaultValue="editor" className={cn("flex flex-col gap-3", className)}>
      <TabsList className="self-start">
        <TabsTrigger value="editor">
          <Pencil className="w-3.5 h-3.5" aria-hidden="true" />
          Editor
        </TabsTrigger>
        <TabsTrigger value="preview">
          <Eye className="w-3.5 h-3.5" aria-hidden="true" />
          Preview
        </TabsTrigger>
      </TabsList>

      <TabsContent value="editor" className="mt-0">
        <Textarea
          value={value}
          onChange={(e) => onChange(e.target.value)}
          rows={rows}
          placeholder={placeholder}
          className="font-mono text-[0.875rem] leading-relaxed min-h-[20rem]"
          spellCheck="false"
        />
      </TabsContent>

      <TabsContent value="preview" className="mt-0">
        <div className="min-h-[20rem] px-4 py-4 bg-background border border-input rounded-md">
          {value.trim() ? (
            <ChangelogMarkdown>{value}</ChangelogMarkdown>
          ) : (
            <p className="text-sm text-muted-foreground italic">Nada para visualizar.</p>
          )}
        </div>
      </TabsContent>
    </Tabs>
  );
};
